import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCard,{attrs:{"flat":""}},[_c(VCardTitle,[_vm._v(" "+_vm._s(_vm.cert[_vm.keyP].name)+" ")]),_c(VCardText,{staticClass:"px-5 pa-0 text-left"},[_vm._v(" "+_vm._s(_vm.cert[_vm.keyP].description)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }